// ─────────────────────────────────────────────────────────────────
// Glass-i — Off-cut register API client (Stage INVENTORY-OFFCUTS-1).
//
// Thin axios wrappers around /api/erp/inventory/offcuts/*. The label is fetched
// through the shared client (so the in-memory Bearer token is attached) and
// returned as the raw HTML string; transformResponse is bypassed so axios never
// tries to JSON-parse the markup. The caller opens it in a new tab to print.
// ─────────────────────────────────────────────────────────────────

import client from '../../../../api/client';

const BASE = '/api/erp/inventory/offcuts';
const enc = encodeURIComponent;

function unwrap(resp) {
  return resp && resp.data && resp.data.data !== undefined ? resp.data.data : resp && resp.data;
}

export const offcutApi = {
  list:    (params = {}) => client.get(BASE, { params }).then(unwrap),
  pivot:   (params = {}) => client.get(`${BASE}/pivot`, { params }).then(unwrap),
  lookups: (params = {}) => client.get(`${BASE}/lookups`, { params }).then(unwrap),
  get:     (id)          => client.get(`${BASE}/${enc(id)}`).then(unwrap),
  create:  (payload)     => client.post(BASE, payload).then(unwrap),
  update:  (id, payload) => client.patch(`${BASE}/${enc(id)}`, payload).then(unwrap),
  remove:  (id)          => client.delete(`${BASE}/${enc(id)}`).then(unwrap),
  labelHtml: (id) => client
    .get(`${BASE}/${enc(id)}/label`, {
      responseType: 'text',
      headers: { Accept: 'text/html' },
      transformResponse: (data) => data
    })
    .then((resp) => resp.data),

  // Batch labels for all off-cuts of a cutting plan → one printable HTML.
  // params: { sourceCuttingPlanId }
  labelsHtml: (params = {}) => client
    .get(`${BASE}/labels`, {
      params,
      responseType: 'text',
      headers: { Accept: 'text/html' },
      transformResponse: (data) => data
    })
    .then((resp) => resp.data)
};

export default offcutApi;
